<template>
  <div class="holder" v-if="Object.values(errors).length">
    <!-- Disclaimer here -->
    <p class="message">
      Uh oh! We found some errors. Please correct the following records and try
      again.
    </p>

    <!-- Errors here -->
    <div
      class="error-region"
      v-for="(error, i) in Object.values(errors)"
      :key="i"
    >
      <img src="../../assets/alert-icon.svg" alt="alert-icon" />

      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      errors: state => state.recipient.recipientErrors
    })
  }
}
</script>

<style lang="scss" scoped>
.holder {
  text-align: left;
  margin: 3.5rem 0 7rem 0;
  color: #da5737;

  .message {
    font-weight: bold;
    padding-bottom: 1.75rem;
  }

  .error-region {
    display: flex;
    align-items: center;
    padding-bottom: 1.25rem;

    p {
      font-size: 0.875rem;
      font-weight: 400;

      &:nth-child(2) {
        margin: 0rem 1.25rem;
      }
    }
  }
}
</style>
